.footer {
    background: #013332 !important;
    font-size: 12px !important;
}